import React, { FC } from 'react';
import { useCallback } from 'react';

import { Popup } from 'devextreme-react/popup';

import { ContractorObject } from 'pages/Contractor';

type CreateObjectModalProps = {
  id: number | null;
  refresh: () => void;
  visible: boolean;
  changeVisible: (val: boolean) => void;
};

const CreateObjectModal: FC<CreateObjectModalProps> = ({ id, visible, refresh, changeVisible }) => {
  const onHidden = useCallback(() => {
    refresh();
  }, [refresh]);

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        enableBodyScroll
        showTitle={true}
        title="Объект"
        width={900}
        onHidden={onHidden}
        height={'auto'}
        showCloseButton
        maxHeight={700}
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <ContractorObject onChangeSelect={() => {}} idFromTaskForm={id} />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateObjectModal;
